'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { refreshPrV2 } from './fetch-pr-v2';
export function usePrV2Refresh(owner, repo, number) {
  const $ = _c(4);
  let t0;
  if ($[0] !== number || $[1] !== owner || $[2] !== repo) {
    t0 = {
      mutationFn: () => refreshPrV2(owner, repo, number)
    };
    $[0] = number;
    $[1] = owner;
    $[2] = repo;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return useMutation(t0);
}